'use strict';

var userSessionStoreCore = require('@zillow/user-session-store-core');

/**
 * Forwards subscribe to global store if it exists.
 * Binds listener with updated state.
 * @param  {Function} listener
 *                      store change callback with nextState as sole argument
 * @return {Function} unsubscriber
 */
function subscribeToUserSessionStore(listener) {
    if (userSessionStoreCore.hasUserSessionStore()) {
        var store = userSessionStoreCore.getUserSessionStore();

        return store.subscribe(function () {
            listener(store.getState());
        });
    }

    console.error('UserSession store is undefined');
    return null;
}

module.exports = subscribeToUserSessionStore;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/user-session-store-subscribe/lib/index.js
// module id = 265
// module chunks = 0 1